import Swal from 'sweetalert2'
import {
    DELETE_PERMISSION,
    GET_PERMISSION_INFO,
    IS_LOADING_ACTIVE_PERMISSION_LIST,
    ACTIVE_PERMISSION_LIST,
    IS_LOADING_INACTIVE_PERMISSION_LIST,
    INACTIVE_PERMISSION_LIST,
    DELETE_TYPE_MANAGER,
    CREATE_TYPE_MANAGER,
    GET_TYPE_MANAGER_INFO,
    IS_LOADING_ACTIVE_TYPE_MANAGER_LIST,
    ACTIVE_TYPE_MANAGER_LIST,
    IS_LOADING_INACTIVE_TYPE_MANAGER_LIST,
    INACTIVE_TYPE_MANAGER_LIST,
    CHANGE_TO_INACTIVE_PERMISSION,
    CHANGE_TO_ACTIVE_PERMISSION,
    CHANGE_TO_ACTIVE_TYPE_MANAGER,
    CHANGE_TO_INACTIVE_TYPE_MANAGER,
    EDIT_TYPE_MANAGER,
    CREATE_PERMISSION,
    EDIT_PERMISSION,
    IS_LOADING_PERMISSION_LIST_ADMIN,
    PERMISSION_LIST_ADMIN,
    CREATE_PERMISSION_ADMIN,
    DELETE_PERMISSION_ADMIN,
    EDIT_PERMISSION_ADMIN,
    GET_PERMISSION_INFO_ADMIN,
    IS_LOADING_ROLES_LIST_ADMIN,
    CREATE_ROLE_ADMIN,
    EDIT_ROLE_ADMIN,
    DELETE_ROLE_ADMIN,
    GET_ROLE_INFO,
    ROLE_LIST_ADMIN,
    IS_LOADING_LIST_ADMIN,
    CREATE_ADMIN,
    EDIT_ADMIN,
    DELETE_ADMIN,
    GET_ADMIN_INFO,
    LIST_ADMIN,
    IS_LOADING_ACTIVE_PROFESSIONAL_PERMISSION_LIST,
    CREATE_PROFESSIONAL_PERMISSION,
    IS_LOADING_INACTIVE_PROFESSIONAL_PERMISSION_LIST,
    DELETE_PROFESSIONAL_PERMISSION,
    EDIT_PROFESSIONAL_PERMISSION,
    CHANGE_TO_ACTIVE_PROFESSIONAL_PERMISSION,
    CHANGE_TO_INACTIVE_PROFESSIONAL_PERMISSION,
    GET_PROFESSIONAL_PERMISSION_INFO,
    ACTIVE_PROFESSIONAL_PERMISSION_LIST,
    INACTIVE_PROFESSIONAL_PERMISSION_LIST,
    IS_LOADING_ACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST,
    IS_LOADING_INACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST,
    CHANGE_TO_ACTIVE_ROLE_PROFESSIONAL_COMMUNITY,
    CHANGE_TO_INACTIVE_ROLE_PROFESSIONAL_COMMUNITY,
    CREATE_ROLE_PROFESSIONAL_COMMUNITY,
    DELETE_ROLE_PROFESSIONAL_COMMUNITY,
    EDIT_ROLE_PROFESSIONAL_COMMUNITY,
    GET_ROLE_PROFESSIONAL_COMMUNITY_INFO,
    ACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST,
    INACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST,
    GET_MY_ADMIN_INFO
} from './types'
import {
    urlServer
} from '../../config/GlobalConstant'
import inMemoryJWT from '../../auth/inMemoryJwt';
///GLOBAL ADMIN
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000
})
//permission in roles in global admin


export const createPermissionAdmin = (permission, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/admin/create-permission-admin`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify(permission)
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                {
                    dispatch({
                        type: IS_LOADING_PERMISSION_LIST_ADMIN
                    });
                    dispatch({
                        type: CREATE_PERMISSION_ADMIN,
                        payload: respJson.data
                    });
                }
            }
        })
        .catch(error => {
            console.log()
        })
}

export const deletePermissionAdmin = (id, index) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/admin/delete-permission-admin`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                permissionId: id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_PERMISSION_LIST_ADMIN
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_PERMISSION_ADMIN,
                    payload: index
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const editPermissionAdmin = (permissionEdited, history, index) => async dispatch => {
    console.log()
     
    await fetch(`${urlServer}adminroles/update`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify(permissionEdited)
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                var data = respJson.data
                dispatch({
                    type: IS_LOADING_PERMISSION_LIST_ADMIN
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: EDIT_PERMISSION_ADMIN,
                    payload: {
                        index,
                        data
                    }
                });
                history.push("/Admin/ListRoles")
            }

        })
        .catch(error => {
            console.log()
        })
}

export const getPermissionInfoAdmin = (id, history) => async dispatch => {

    await fetch(`${urlServer}api/admin/get-permission-admin-id`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                permissionId: id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_PERMISSION_INFO_ADMIN,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const getPermissionsAdmin = () => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_PERMISSION_LIST_ADMIN
    });
    await fetch(`${urlServer}adminpermissions/get-all`, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: PERMISSION_LIST_ADMIN,
                payload: respJson.data || []
            });
        })
        .catch(error => {
            console.log()
        })
}


export const searchPermissionsAdmin = (search, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/admin/search-permission-admin`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header  
            body: JSON.stringify(search)
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_PERMISSION_LIST_ADMIN
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: PERMISSION_LIST_ADMIN,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}


///roles admin management
export const createRoleAdmin = (role, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}adminroles/create`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify(role)
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if(respJson.success){
                dispatch({
                    type: CREATE_ROLE_ADMIN,
                    payload: respJson.data
                });
                history.push("/Admin/ListRoles")
            }
           
               
            
        })
        .catch(error => {
            console.log()
        })
}

export const editRoleAdmin = (roleEdited, history, index) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/admin/update-role-admin`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify(roleEdited)
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true)

            {
                dispatch({
                    type: IS_LOADING_ROLES_LIST_ADMIN
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: EDIT_ROLE_ADMIN,
                    payload: {
                        index: index,
                        data: respJson.data
                    }
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const deleteRoleAdmin = (id, index) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/admin/delete-role-admin`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                roleId: id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_ROLES_LIST_ADMIN
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_ROLE_ADMIN,
                    payload: index
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getRoleInfo = (id, history) => async dispatch => {

    await fetch(`${urlServer}adminroles/get-id`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                roleId: id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_ROLE_INFO,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}
export const clearRoleInfo = (id, history) => async dispatch => {

    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: GET_ROLE_INFO,
        payload: []
    });
}

export const getRoleList = () => async dispatch => {

    await fetch(`${urlServer}adminroles/get-all`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                   dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_ROLES_LIST_ADMIN
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: ROLE_LIST_ADMIN,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const searchRoleList = (search, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/admin/search-role-admin`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify(search)
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_ROLES_LIST_ADMIN
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: ROLE_LIST_ADMIN,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

/// admin users management
export const createAdmin = (admin, history) => async dispatch => {
    for (var pair of admin.entries()) {
        console.log();
    }
    await fetch(`${urlServer}adminusers/create`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: admin
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if(respJson.error && respJson.error.code==="ERR095"){
                Toast.fire({
                    icon: 'error',
                    title: 'El correo ya posee una cuenta'
                })
            }
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_LIST_ADMIN
                });
                dispatch({
                    type: CREATE_ADMIN,
                    payload: respJson.data
                });
                history.push("/Admin/ListAdmin")
            }
        })
        .catch(error => {
            console.log()
        })
}

export const editAdmin = (adminEdited, history,index) => async dispatch => {
    for (var pair of adminEdited.entries()) {
        console.log();
    }
    await fetch(`${urlServer}adminusers/update`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                //'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: adminEdited
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true)

            {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_LIST_ADMIN
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: EDIT_ADMIN,
                    payload: {
                        index: index,
                        data: respJson.data
                    }
                });
                history.push("/Admin/ListAdmin")
            }

        })
        .catch(error => {
            console.log()
        })
}

export const deleteAdmin = (id, index) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/admin/delete-user-admin`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                adminUserId: id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_LIST_ADMIN
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_ADMIN,
                    payload: index
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getAdminInfo = (id, history) => async dispatch => {

    await fetch(`${urlServer}adminusers/get-by-id`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                adminUserId: id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_ADMIN_INFO,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}
export const getMyAdminInfo = (id, history) => async dispatch => {

    await fetch(`${urlServer}adminusers/get-by-id`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                adminUserId: id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_MY_ADMIN_INFO,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}


export const getAdminList = (history) => async dispatch => {

    await fetch(`${urlServer}adminusers/get-all`, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_LIST_ADMIN
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: LIST_ADMIN,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const searchAdminList = (search, history) => async dispatch => {

    await fetch(`${urlServer}api/admin/search-user-admin`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify(search)
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_LIST_ADMIN
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: LIST_ADMIN,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

///ADMINS IN COMMUNITY
//// permission to roles in communities management

export const createPermission = (permission, history) => async dispatch => {

    await fetch(`${urlServer}api/communities/manager/permissions/create`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                //  'Authorization': `bearer ${accessToken}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify(permission)
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                {
                    dispatch({
                        type: IS_LOADING_ACTIVE_PERMISSION_LIST
                    });
                    dispatch({
                        type: CREATE_PERMISSION,
                        payload: respJson.data
                    });
                }
            }
        })
        .catch(error => {
            console.log()
        })
}

export const deletePermission = (id, index, fromWhere) => async dispatch => {

    await fetch(`${urlServer}api/communities/manager/permissions/delete`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                id: id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (fromWhere === 'activePermissions') {
                dispatch({
                    type: IS_LOADING_ACTIVE_PERMISSION_LIST
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_PERMISSION,
                    payload: {
                        index,
                        fromWhere
                    }
                });
            }
            if (fromWhere === 'inactivePermissions') {
                dispatch({
                    type: IS_LOADING_INACTIVE_PERMISSION_LIST
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_PERMISSION,
                    payload: {
                        index,
                        fromWhere
                    }
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const editPermission = (permissionEdited, history, actionEnabled, index) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/communities/manager/permissions/update`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                //'Authorization': `bearer ${accessToken}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify(permissionEdited)
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true && actionEnabled === undefined) {
                var data = respJson.data
                dispatch({
                    type: IS_LOADING_ACTIVE_PERMISSION_LIST
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: EDIT_PERMISSION,
                    payload: {
                        index,
                        data
                    }
                });
            }

            if (respJson.success === true && actionEnabled === 'activate') {
                dispatch({
                    type: IS_LOADING_ACTIVE_PERMISSION_LIST
                });
                dispatch({
                    type: IS_LOADING_INACTIVE_PERMISSION_LIST
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: CHANGE_TO_ACTIVE_PERMISSION,
                    payload: index
                });
            }
            if (respJson.success === true && actionEnabled === 'deactivate') {
                dispatch({
                    type: IS_LOADING_INACTIVE_PERMISSION_LIST
                });
                dispatch({
                    type: IS_LOADING_ACTIVE_PERMISSION_LIST
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: CHANGE_TO_INACTIVE_PERMISSION,
                    payload: index
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getPermissionInfo = (id, history) => async dispatch => {

    await fetch(`${urlServer}api/communities/manager/permissions/get/id`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                id: id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_PERMISSION_INFO,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const getActivePermissions = (id, history) => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_ACTIVE_PERMISSION_LIST
    });
    await fetch(`${urlServer}api/communities/manager/permissions/get/activePermissions`, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: ACTIVE_PERMISSION_LIST,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const getInactivePermissions = (id, history) => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_INACTIVE_PERMISSION_LIST
    });
    await fetch(`${urlServer}api/communities/manager/permissions/get/inactivePermissions`, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: INACTIVE_PERMISSION_LIST,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

//// type manager methods management
export const createTypeManager = (typeManager, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/communities/typeManager/create`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify(typeManager)
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_ACTIVE_TYPE_MANAGER_LIST
                });
                dispatch({
                    type: CREATE_TYPE_MANAGER,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const editTypeManager = (typeManagerEdited, history, actionEnabled, index) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/communities/typeManager/update`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify(typeManagerEdited)
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true && actionEnabled === undefined)

            {
                dispatch({
                    type: IS_LOADING_ACTIVE_TYPE_MANAGER_LIST
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: EDIT_TYPE_MANAGER,
                    payload: {
                        index: index,
                        data: respJson.data
                    }
                });
            }

            if (respJson.success === true && actionEnabled === 'activate') {
                dispatch({
                    type: IS_LOADING_ACTIVE_TYPE_MANAGER_LIST
                });
                dispatch({
                    type: IS_LOADING_INACTIVE_TYPE_MANAGER_LIST
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: CHANGE_TO_ACTIVE_TYPE_MANAGER,
                    payload: index
                });
            }
            if (respJson.success === true && actionEnabled === 'deactivate') {
                dispatch({
                    type: IS_LOADING_INACTIVE_TYPE_MANAGER_LIST
                });
                dispatch({
                    type: IS_LOADING_ACTIVE_TYPE_MANAGER_LIST
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: CHANGE_TO_INACTIVE_TYPE_MANAGER,
                    payload: index
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const deleteTypeManager = (id, index, fromWhere) => async dispatch => {

    await fetch(`${urlServer}api/communities/typeManager/delete`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                id: id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (fromWhere === 'activeTypeManager') {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_ACTIVE_TYPE_MANAGER_LIST
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_TYPE_MANAGER,
                    payload: {
                        index,
                        fromWhere
                    }
                });
            }
            if (fromWhere === 'inactiveTypeManager') {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_INACTIVE_TYPE_MANAGER_LIST
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_TYPE_MANAGER,
                    payload: {
                        index,
                        fromWhere
                    }
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getTypeManagerInfo = (id, history) => async dispatch => {

    await fetch(`${urlServer}api/communities/typeManager/get/id`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                id: id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_TYPE_MANAGER_INFO,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const getActiveTypeManager = (history) => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_ACTIVE_TYPE_MANAGER_LIST
    });
    await fetch(`${urlServer}api/communities/typeManager/get/actives`, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: ACTIVE_TYPE_MANAGER_LIST,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const getInactiveTypeManager = (history) => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_INACTIVE_TYPE_MANAGER_LIST
    });
    await fetch(`${urlServer}api/communities/typeManager/get/inactives`, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: INACTIVE_TYPE_MANAGER_LIST,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

///ADMINS PROFESSIONAL COMMUNITY 
//// permission to roles in communities in professional management

export const createPermissionProfessional = (permission, history) => async dispatch => {

    await fetch(`${urlServer}api/professionalcommunities/professionals/permissions/create`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify(permission)
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                {
                    dispatch({
                        type: IS_LOADING_ACTIVE_PROFESSIONAL_PERMISSION_LIST
                    });
                    dispatch({
                        type: CREATE_PROFESSIONAL_PERMISSION,
                        payload: respJson.data
                    });
                }
            }
        })
        .catch(error => {
            console.log()
        })
}

export const deletePermissionProfessional = (id, index, fromWhere) => async dispatch => {

    await fetch(`${urlServer}api/professionalcommunities/professionals/permissions/delete`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                id: id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (fromWhere === 'activePermissions') {
                dispatch({
                    type: IS_LOADING_ACTIVE_PROFESSIONAL_PERMISSION_LIST
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_PROFESSIONAL_PERMISSION,
                    payload: {
                        index,
                        fromWhere
                    }
                });
            }
            if (fromWhere === 'inactivePermissions') {
                dispatch({
                    type: IS_LOADING_INACTIVE_PROFESSIONAL_PERMISSION_LIST
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_PROFESSIONAL_PERMISSION,
                    payload: {
                        index,
                        fromWhere
                    }
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const editPermissionProfessional = (permissionEdited, history, actionEnabled, index) => async dispatch => {

    await fetch(`${urlServer}api/professionalcommunities/professionals/permissions/update`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',
                //'Authorization': `bearer ${accessToken}`

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify(permissionEdited)
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true && actionEnabled === undefined) {
                var data = respJson.data
                dispatch({
                    type: IS_LOADING_ACTIVE_PROFESSIONAL_PERMISSION_LIST
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: EDIT_PROFESSIONAL_PERMISSION,
                    payload: {
                        index,
                        data
                    }
                });
            }

            if (respJson.success === true && actionEnabled === 'activate') {
                dispatch({
                    type: IS_LOADING_ACTIVE_PROFESSIONAL_PERMISSION_LIST
                });
                dispatch({
                    type: IS_LOADING_INACTIVE_PROFESSIONAL_PERMISSION_LIST
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: CHANGE_TO_ACTIVE_PROFESSIONAL_PERMISSION,
                    payload: index
                });
            }
            if (respJson.success === true && actionEnabled === 'deactivate') {
                dispatch({
                    type: IS_LOADING_INACTIVE_PROFESSIONAL_PERMISSION_LIST
                });
                dispatch({
                    type: IS_LOADING_ACTIVE_PROFESSIONAL_PERMISSION_LIST
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: CHANGE_TO_INACTIVE_PROFESSIONAL_PERMISSION,
                    payload: index
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getPermissionProfessionalInfo = (id, history) => async dispatch => {

    await fetch(`${urlServer}api/professionalcommunities/professionals/permissions/get/id`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                id: id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_PROFESSIONAL_PERMISSION_INFO,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const getActivePermissionsProfessional = (id, history) => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_ACTIVE_PERMISSION_LIST
    });
    await fetch(`${urlServer}api/professionalcommunities/professionals/permissions/get/activePermissions`, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: ACTIVE_PROFESSIONAL_PERMISSION_LIST,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const getInactivePermissionsProfessional = (id, history) => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_INACTIVE_PROFESSIONAL_PERMISSION_LIST
    });
    await fetch(`${urlServer}api/professionalcommunities/professionals/permissions/get/inactivePermissions`, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: INACTIVE_PROFESSIONAL_PERMISSION_LIST,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

//// roles in communities in professional management
export const createRoleCommunityProfessional = (roleCommunityProfessional, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/professionalcommunities/roles/create`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify(roleCommunityProfessional)
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_ACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST
                });
                dispatch({
                    type: CREATE_ROLE_PROFESSIONAL_COMMUNITY,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const editRoleCommunityProfessional = (roleCommunityProfessional, history, actionEnabled, index) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/professionalcommunities/roles/update`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify(roleCommunityProfessional)
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true && actionEnabled === undefined)

            {
                dispatch({
                    type: IS_LOADING_ACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: EDIT_ROLE_PROFESSIONAL_COMMUNITY,
                    payload: {
                        index: index,
                        data: respJson.data
                    }
                });
            }

            if (respJson.success === true && actionEnabled === 'activate') {
                dispatch({
                    type: IS_LOADING_ACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST
                });
                dispatch({
                    type: IS_LOADING_INACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: CHANGE_TO_ACTIVE_ROLE_PROFESSIONAL_COMMUNITY,
                    payload: index
                });
            }
            if (respJson.success === true && actionEnabled === 'deactivate') {
                dispatch({
                    type: IS_LOADING_INACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST
                });
                dispatch({
                    type: IS_LOADING_ACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: CHANGE_TO_INACTIVE_ROLE_PROFESSIONAL_COMMUNITY,
                    payload: index
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const deleteRoleCommunityProfessional = (id, index, fromWhere) => async dispatch => {

    await fetch(`${urlServer}api/professionalcommunities/roles/delete`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                id: id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (fromWhere === 'activeRole') {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_ACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_ROLE_PROFESSIONAL_COMMUNITY,
                    payload: {
                        index,
                        fromWhere
                    }
                });
            }
            if (fromWhere === 'inactiveRole') {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_INACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_ROLE_PROFESSIONAL_COMMUNITY,
                    payload: {
                        index,
                        fromWhere
                    }
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getRoleCommunityProfessionalInfo = (id, history) => async dispatch => {

    await fetch(`${urlServer}api/professionalcommunities/roles/get/id`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                id: id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_ROLE_PROFESSIONAL_COMMUNITY_INFO,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const getActiveRoleCommunityProfessional = (history) => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_ACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST
    });
    await fetch(`${urlServer}api/professionalcommunities/roles/get/actives`, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: ACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const getInactiveRoleCommunityProfessional = (history) => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_INACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST
    });
    await fetch(`${urlServer}api/professionalcommunities/roles/get/inactives`, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: INACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}